/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Objects of type DeviceLiveLogUpdateSrm are sent to hub method named deviceLiveLogUpdateMessage in the device group device_<deviceId>. Srm == SignalR Message. Listen to it via `signalRHub.on('deviceLiveLogUpdateMessage', (message: DeviceLiveLogUpdateSrm) => {}`
 * @export
 * @interface DeviceLiveLogUpdateSrm
 */
export interface DeviceLiveLogUpdateSrm {
    /**
     *
     * @type {string}
     * @memberof DeviceLiveLogUpdateSrm
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceLiveLogUpdateSrm
     */
    deviceType?: DeviceLiveLogUpdateSrmDeviceTypeEnum;
    /**
     *
     * @type {Date}
     * @memberof DeviceLiveLogUpdateSrm
     */
    timestampUtc?: Date;
    /**
     *
     * @type {string}
     * @memberof DeviceLiveLogUpdateSrm
     */
    sender?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceLiveLogUpdateSrm
     */
    messageId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceLiveLogUpdateSrm
     */
    type?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceLiveLogUpdateSrm
     */
    action?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceLiveLogUpdateSrm
     */
    payload?: string;
}

/**
 * @export
 */
export const DeviceLiveLogUpdateSrmDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type DeviceLiveLogUpdateSrmDeviceTypeEnum =
    (typeof DeviceLiveLogUpdateSrmDeviceTypeEnum)[keyof typeof DeviceLiveLogUpdateSrmDeviceTypeEnum];

/**
 * Check if a given object implements the DeviceLiveLogUpdateSrm interface.
 */
export function instanceOfDeviceLiveLogUpdateSrm(
    value: object,
): value is DeviceLiveLogUpdateSrm {
    return true;
}

export function DeviceLiveLogUpdateSrmFromJSON(
    json: any,
): DeviceLiveLogUpdateSrm {
    return DeviceLiveLogUpdateSrmFromJSONTyped(json, false);
}

export function DeviceLiveLogUpdateSrmFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceLiveLogUpdateSrm {
    if (json == null) {
        return json;
    }
    return {
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        timestampUtc:
            json["timestampUtc"] == null
                ? undefined
                : new Date(json["timestampUtc"]),
        sender: json["sender"] == null ? undefined : json["sender"],
        messageId: json["messageId"] == null ? undefined : json["messageId"],
        type: json["type"] == null ? undefined : json["type"],
        action: json["action"] == null ? undefined : json["action"],
        payload: json["payload"] == null ? undefined : json["payload"],
    };
}

export function DeviceLiveLogUpdateSrmToJSON(
    value?: DeviceLiveLogUpdateSrm | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceId: value["deviceId"],
        deviceType: value["deviceType"],
        timestampUtc:
            value["timestampUtc"] == null
                ? undefined
                : value["timestampUtc"].toISOString(),
        sender: value["sender"],
        messageId: value["messageId"],
        type: value["type"],
        action: value["action"],
        payload: value["payload"],
    };
}
